module.exports = __webpack_public_path__ + "static/media/002.0a81788c.jpg";